<template>
  <v-app v-if="$store.borrowerWebContent !== undefined">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import snContentService from '../../../services/snContentService'

export default {
  name: 'App',
  data () {
    return {
      store: this.$store
    }
  },
  computed: {
    sac () {
      const path = location.pathname
      const regexp = /[^/]+@[^/]+\.[^?]+/i
      return path.match(regexp)?.[0] || ''
    }
  },
  created () {
    this.setUpBorrowerWebContent()
  },
  methods: {
    async setUpBorrowerWebContent () {
      const { data: { content } } = await snContentService.borrowerWebContent(this.sac)
      if (content) {
        this.store.borrowerWebContent = JSON.parse(content)
      }
    }
  }
}
</script>
